import axios from "axios";

const URL = process.env.REACT_APP_USER_API;

export async function getFinanceCodes() {
  console.log("getFinanceCodes")
  let url = URL + "/finance";
  let response = await axios.get(url);
  console.log("getFinanceCodes response", response)
  return response.data;
}

export async function addFinanceCode(payload){
  let url = URL + "/addfinancecode";
  let response = await axios.post(url, payload);
  return response.data;
}
export async function addFinanceCodeBatch(payload){
  let url = URL + "/addfinancebatch";
  let response = await axios.post(url, payload);
  return response.data;
}
export async function getFilteredCodes(payload){
  let url = URL + "/filteredcodes";
  let response = await axios.post(url, payload);
  return response.data;
}

export async function updateFinanceCode(payload){
  console.log("updateFinanceCode payload")
  let url = URL + "/updatefinance";
  let response = await axios.post(url, payload);
  console.log("updateFinanceCode response",response)
  return response.data;
}

export async function editFinanceCode(payload){
  let url = URL + "/editfinance";
  let response = await axios.post(url, payload);
  return response.data;
}